import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/mine/null.png'


const _withScopeId = n => (_pushScopeId("data-v-6012a84b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 0,
  class: "sub"
}
const _hoisted_6 = {
  key: 1,
  class: "sub"
}
const _hoisted_7 = {
  key: 1,
  class: "null"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "null-img"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "暂无数据～", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { ActivityFetch } from '../api/request';
import { onMounted, ref } from 'vue';
import { PaginationProps, usTaskEroSituationProps } from '@/api/type';
import { fullUrl } from '@/lib';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const taskIds = router?.currentRoute?.value?.query?.taskId;
const taskId = Array.isArray(taskIds) ? taskIds[0] as string : taskIds || '';
const finishedErolist = ref(false);
const paginationErolist = ref<PaginationProps>({
  pageNum: 0,
  pageSize: 5
});
const loadingErolist = ref(false);
const userId = window.localStorage.getItem('userId') || '';
const erolist = ref<usTaskEroSituationProps[]>([]);
const onLoadErolist = async () => {
  // 异步更新数据
  loadingErolist.value = true;

  paginationErolist.value.pageNum += 1;
  const params = {
    pageNum: paginationErolist.value.pageNum,
    pageSize: paginationErolist.value.pageSize,
    taskId, userId
  };

  const res = await ActivityFetch.usTaskEroSituation(params);
  const body = res.body;
  if (Array.isArray(body)) {
    erolist.value = erolist.value.concat(body);
    // 加载状态结束
    loadingErolist.value = false;

    // 到底了
    if (body.length === 0 || body.length < paginationErolist.value.pageSize) {
      finishedErolist.value = true;
    }
  }
  if (!body) {
    finishedErolist.value = true;
  }
};
onMounted(() => {
  onLoadErolist()
})

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (erolist.value.length > 0)
      ? (_openBlock(), _createBlock(_component_van_list, {
          key: 0,
          loading: loadingErolist.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loadingErolist).value = $event)),
          finished: finishedErolist.value,
          "finished-text": "没有更多了",
          onLoad: onLoadErolist,
          class: "sign-box"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(erolist.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.id
              }, [
                _createElementVNode("img", {
                  src: _unref(fullUrl)(item.headImgUrl),
                  class: "left"
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item.userName), 1),
                  (item.unvsName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.unvsName) + " · " + _toDisplayString(item.psfnName), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, "初来乍到"))
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
  ]))
}
}

})